import { gql } from '@apollo/client';

export interface CreditSeriesPointProps {
  __typename?: 'SeriesPoint';
  competence: string;
  value: number;
}

export interface CreditCounterpartSeriesProps {
  __typename?: 'CounterpartSeries';
  mwmByCompetence: CreditSeriesPointProps[];
  mtmByCompetence: CreditSeriesPointProps[];
}

export interface CreditCounterpartyDetailFilterProps {
  startCompetence?: string;
  endCompetence?: string;
}

export interface PayloadProps {
  accountId: string;
  filter?: CreditCounterpartyDetailFilterProps;
}

export interface CreditCounterpartyDetailProps {
  __typename?: 'CounterpartDetail';
  counterpartName: string;
  taxId?: string;
  rating?: string;
  negotiationDeadlineLabel?: string;
  exposureMtmFiltered: number;
  exposureMtmGlobal: number;
  limitAverage: number;
  financialBalance: number;
  series: CreditCounterpartSeriesProps;
}

export interface ResponseProps {
  creditCounterpartDetail: CreditCounterpartyDetailProps;
}

const CREDIT_COUNTERPARTY_DETAIL = gql`
  query creditCounterpartDetail($accountId: ID!, $filter: CreditCounterpartDetailFilter) {
    creditCounterpartDetail(accountId: $accountId, filter: $filter) {
      counterpartName
      taxId
      rating
      negotiationDeadlineLabel
      exposureMtmFiltered
      exposureMtmGlobal
      limitAverage
      financialBalance
      series {
        mwmByCompetence {
          competence
          value
        }
        mtmByCompetence {
          competence
          value
        }
      }
    }
  }
`;

export default CREDIT_COUNTERPARTY_DETAIL;
